import { SUPER_USER_ROLE } from 'src/constants/Constants'
import AuthStore from 'src/store/modules/authorization'
import ProfileStore from 'src/store/modules/profile'
import * as NameSpace from 'src/store/NameSpace'

export function isSuperUser () {
  let auth = AuthStore.getters[NameSpace.AUTH_GETTER](AuthStore.state)
  auth = auth.auth
  if (auth && auth.user_group) {
    if (auth.user_group.indexOf(SUPER_USER_ROLE) !== -1) {
      return true
    }
  }
  return false
}

export function getVendorId () {
  let profile = ProfileStore.getters[NameSpace.GETTER_EMAIL_SELECTED_BY_SUPERUSER](ProfileStore.state)
  if (profile) {
    return profile
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/helper/superUser.js